import { createConfig, http } from "wagmi";
import { base, sepolia, mainnet } from "wagmi/chains";
import { injected, walletConnect, coinbaseWallet } from "wagmi/connectors";

// EIP-6963 + EIP-7702 compatible.
// - Base is the production chain — listed FIRST so wagmi defaults to it.
// - `injected({ shimDisconnect: true })` auto-discovers every EIP-6963 announced
//   wallet (DogeShit, MetaMask, Rabby, …). After connect we may need to ask the
//   wallet to switch / add Base via the wallet_switchEthereumChain RPC; wagmi's
//   `useSwitchChain` does that automatically.
// - Coinbase Wallet (Smart Wallet) speaks EIP-7702 / EIP-5792 for batched mint.

const WC_PROJECT_ID = import.meta.env.VITE_WC_PROJECT_ID ?? "";

export const wagmiConfig = createConfig({
  chains: [base, sepolia, mainnet],
  connectors: [
    injected({ shimDisconnect: true }),
    coinbaseWallet({ appName: "GAIA", appLogoUrl: "/favicon.svg", preference: "all" }),
    ...(WC_PROJECT_ID
      ? [
          walletConnect({
            projectId: WC_PROJECT_ID,
            metadata: {
              name: "GAIA",
              description: "Mother nature's memecoin",
              url: typeof window !== "undefined" ? window.location.origin : "https://gaiamint.lol",
              icons: ["/favicon.svg"],
            },
            showQrModal: true,
          }),
        ]
      : []),
  ],
  transports: {
    [base.id]:    http(import.meta.env.VITE_BASE_RPC    ?? "https://mainnet.base.org"),
    [sepolia.id]: http(import.meta.env.VITE_SEPOLIA_RPC ?? "https://ethereum-sepolia.publicnode.com"),
    [mainnet.id]: http(import.meta.env.VITE_MAINNET_RPC ?? "https://eth.llamarpc.com"),
  },
  ssr: false,
});

declare module "wagmi" {
  interface Register {
    config: typeof wagmiConfig;
  }
}
